/**
 * Select payment type
 */
export const CHECKOUT_PAYMENT_TYPE_SELECT = 'CHECKOUT_PAYMENT_TYPE_SELECT';

/**
 * Select credit card
 */
export const CHECKOUT_CARD_SELECT = 'CHECKOUT_CARD_SELECT';

/**
 * Select convenience store
 */
export const CHECKOUT_STORE_SELECT = 'CHECKOUT_STORE_SELECT';

/**
 * Set browser payment request as selected mode of payment
 */
export const CHECKOUT_BROWSER_PAYMENT_SELECT =
  'CHECKOUT_BROWSER_PAYMENT_SELECT';

/**
 * Timeslot select
 */
export const CHECKOUT_TIMESLOT_SELECT = 'CHECKOUT_TIMESLOT_SELECT';

/**
 * Ticket select
 */
export const CHECKOUT_TICKET_SET = 'CHECKOUT_TICKET_SET';

/**
 * Order made
 * Made but not neccasarily succesful
 */
export const CHECKOUT_ORDER_MADE = 'CHECKOUT_ORDER_MADE';

/**
 * Order successful
 * Order successfully made
 */
export const CHECKOUT_ORDER_SUCCESSFUL = 'CHECKOUT_ORDER_SUCCESSFUL';

/**
 * Clear basket
 */
export const CHECKOUT_BASKET_CLEAR = 'CHECKOUT_BASKET_CLEAR';
